import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Dependencies } from '../store';

import { ScorecardService } from './core/scorecard.service';
import { ScorecardDataDto } from './scorecard.model';

const chunk = (arr: number[], size: number): number[][] => {
    const num = arr.length;
    let n = 0;
    const chunks = [];
    while (n < num) {
        chunks.push(arr.slice(n, n + size));
        n += size;
    }
    return chunks;
};

const flatten = (coll: ScorecardDataDto[][]): ScorecardDataDto[] => {
    return coll.reduce((p, c) => {
        p.push(...c);
        return p;
    }, []);
};

export function listDataObservable(
    deps: Dependencies,
    scorecardIds: number[],
    useLiveData: boolean,
): Observable<ScorecardDataDto[]> {
    const service = deps.injector.get<ScorecardService>(ScorecardService);

    const chunks = chunk(scorecardIds, 30);
    return forkJoin(chunks.map((e) => service.listData(e, useLiveData))).pipe(
        map((dats) => flatten(dats)),
    );
}
